import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact, { BugsnagErrorBoundary } from '@bugsnag/plugin-react';
import BugsnagPerformance from '@bugsnag/browser-performance';
import * as React from 'react';
import { ExoticComponent, FragmentProps } from 'react';
import { getAppConfig } from './get-app-config';

let ErrorBoundary: ExoticComponent<FragmentProps> | BugsnagErrorBoundary = React.Fragment;

const config = getAppConfig();

if (config?.bugsnag?.apiKey && config.bugsnag.releaseStage) {
	Bugsnag.start({
		apiKey: config.bugsnag.apiKey,
		releaseStage: config.bugsnag.releaseStage,
		appVersion: import.meta.env.VITE_APP_VERSION,
		plugins: [new BugsnagPluginReact()],
	});
	BugsnagPerformance.start({ apiKey: config.bugsnag.apiKey });

	const bugsnagReact = Bugsnag.getPlugin('react');

	if (bugsnagReact) {
		ErrorBoundary = bugsnagReact.createErrorBoundary(React);
	}
}

export { ErrorBoundary };
